/**
 * shared.ts (ordens-compra) — tipos da ordem de compra do site (ficha #42).
 */

export interface Vinculo {
  id?: number;
  pedido_id: number | null;
  ordens_servico_id?: number | null;
  pedido_numero?: string | null;
  cliente?: string | null;
  valor: number;
  pct?: number | null;
  descricao?: string | null;
}

export interface Parcela {
  dias?: number | null;
  vencimento: string;
  valor: number;
}

export interface OrdemCompra {
  id: number;
  loja_id: number;
  loja_codigo: string | null;
  loja_nome: string | null;
  data: string | null;
  contato_tiny: string | null;
  /** a linha da lista de fornecedores da loja (pode ser sugerida) */
  fornecedor_id: number | null;
  fornecedor_cadastro: string | null;
  categoria_tiny: string | null;
  fornecedor: string | null;
  valor_total: number;
  observacoes: string | null;
  observacoes_internas: string | null;
  explicacao: string | null;
  numero_tiny: string | null;
  ordem_compra_tiny: string | null;
  /** nao_enviada | enviando | enviada | verificar */
  envio_tiny: string;
  erro_envio_tiny: string | null;
  enviado_tiny_em: string | null;
  /** Conta lançada no Tiny (migration 121): lá não muda mais. */
  contas_lancadas_tiny?: string | null;
  /** o que aconteceu com o Tiny ao salvar uma OC já enviada */
  sincronia_tiny?: 'ok' | 'so_app' | 'conta_lancada' | 'erro';
  aviso_tiny?: string;
  criado_por: string | null;
  vinculos: Vinculo[];
  parcelas: Parcela[];
}

export const ROTULO_ENVIO: Record<string, { texto: string; classe: string; icone: string }> = {
  nao_enviada: { texto: 'Não enviada', classe: 'text-bg-light border', icone: 'bi-circle' },
  enviando: { texto: 'Com cadeado', classe: 'text-bg-danger', icone: 'bi-lock-fill' },
  verificar: { texto: 'Com cadeado', classe: 'text-bg-danger', icone: 'bi-lock-fill' },
  enviada: { texto: 'No Tiny', classe: 'text-bg-success', icone: 'bi-check-circle-fill' },
};
